import styled from "styled-components";

import * as Dropdown from "ds/Dropdown";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: flex-end;
  gap: 8px;

  .info-button {
    > button {
      justify-content: center;
      border-radius: var(
        --trigger-button-border-radius,
        var(--button-2px-border-radius, var(--2px))
      );
    }
  }

  @media (min-width: 768px) {
    margin-right: 0;
  }
`;

export const Layout = styled.div`
  .tooltip > section {
    padding: 16px;
  }

  > section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    box-sizing: border-box;

    @media (min-width: 960px) {
      flex-direction: row;
      > div {
        max-width: 50%;
      }
    }
  }
  #environment-urls {
    section {
      padding: 0;
      a:hover,
      a:focus {
        text-decoration: underline;
      }
    }
  }
  .rcs-custom-scroll {
    .rcs-inner-container {
      padding: 16px;
      box-sizing: border-box;
    }
    .rcs-inner-handle {
      background-color: var(
        --section-dark-tint-background-color,
        var(--dark-tint)
      );
      width: 4px;
      border-radius: 4px;
      opacity: 1;
    }
  }
  .no-scroll {
    padding: 16px;
  }
  .environment-ssh {
    max-height: 600px;
    overflow: scroll;
  }
  .tooltip-content-wrapper {
    overflow: scroll;
    width: 600px;
  }
  .info-button hr {
    margin-bottom: 0px;
  }
`;

export const Content = styled(Dropdown.Content)`
  padding: 16px;
  border-radius: var(
    --box-wrapper-section-border-radius,
    var(--section-8px-border-radius, var(--8px))
  );
  width: 568px;
`;

export const MessageContainer = styled.div`
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
`;

export const Message = styled.div`
  font-size: 14px;
`;
